var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VPopover',{class:`c-cui-tooltip ${_vm.className}`,attrs:{"trigger":"hover"}},[_c('div',{staticClass:"trigger-wrapper"},[_vm._t("default")],2),_c('template',{slot:"popover"},[_c('main',[_vm._v(_vm._s(_vm.title))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }